// src/constants/affiliations.js
export const AFFILIATIONS = [
    'Estudiante','Academia/Instituto de Investigación','Ciudadano','Consultor',
    'SENASA','Industria','Organización Internacional','ONG',
    'Autoridad Pública en Perú','Autoridad Pública de otro país','Otros',
  ];
 
  